import { MobileView } from 'react-device-detect';

import { RemoveAdsButton } from './RemoveAdsButton';

export const AdnginInContent = () => {
  return (
    <MobileView className="my-4 flex w-full flex-col items-center justify-center">
      <RemoveAdsButton className="mb-2 mt-2" />
      <div id="adngin-incontent-0"></div>
    </MobileView>
  );
};
